import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { environment } from "src/environments/environment";

const BACKEND_URL = environment.apiUrl + "/clusters/";

@Injectable({
  providedIn: "root"
})

export class ClustersService {

  constructor(private http: HttpClient) { }

  getClusters(): Observable<any[]> {
    return this.http
      .get<{ message: string; clusters: any[] }>(BACKEND_URL + '/')
      .pipe(
        map(clusterData => {
          return [...clusterData.clusters];
        })
      );
  }

  clustersformaniger(): Observable<any[]> {
    return this.http
      .get<{ message: string; clusters: any[] }>(BACKEND_URL + '/clustersformaniger')
      .pipe(
        map(clusterData => {
          return [...clusterData.clusters];
        })
      );
  }

  getBranchesByClusterName(cluster: string): Observable<any[]> {
    return this.http
      .get<{ message: string; cluster: any }>(BACKEND_URL + '/byclustername/' + cluster)
      .pipe(
        map(cluster => {
          return cluster.cluster;
        })
      );
  }
  // =======================================
}


